import { get } from "../GenericServices";

const ExportProject = {
  exportSapFinanceStatement: (queryString) => {
    return get(`export-project/finance-statement-progress?${queryString}`);
  },
  exportSapIncomeStatement: (queryString) => {
    return get(`export-project/income-statement-progress?${queryString}`);
  },
};

export default ExportProject;
